import React, { Component } from "react";
import MaterialTable from "material-table";
import UiUtils from "../../../provider/UiUtils";
import { withRouter } from "../../../withRouter";
import FetchServerData from "../../../provider/FetchServerData";
import { Card, CardBody } from "reactstrap";
import { MenuWithBreadScrum } from "../../menu/MenuWithBreadScrum";
import store from "../../../redux/store";
import PrintRoundedIcon from "@material-ui/icons/PrintRounded";
import ReactToPrint from "react-to-print";
import Button from "@material-ui/core/Button";
import CustomerAction from "../../../redux/customer/CustomerAction";
import Utils from "../../../provider/Utils";
import BackIconButton from "../../buttons/BackIconButton";

class CustomerReportList extends Component {
  header = store.getState().header.header;
  breadCrumb = [
    { pageid: "/reports", uiname: "MIS Reports" },
    { pageid: "/customerAnalytics", uiname: "Customer Analytics" },
    { pageid: "", uiname: "Customer List" },
  ];

  constructor() {
    super();
    this.state = {
      initialPage: 0,
      pageSize: 10,
      customerList: [],
      isPaging: false,
      render: false,
    };
    this.getCustomerList();
  }
  getCustomerList() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService("/misms/customerList", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let customerList = output.data.customerList;
          store.dispatch(CustomerAction.setCustomer(customerList));
          let isPaging = false;
          if (customerList.length > this.state.pageSize) {
            isPaging = true;
          }
          this.setState({
            render: true,
            isPaging: isPaging,
            customerList: customerList,
            initialPage: this.state.initialPage,
          });
        } 
      }
    );
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ initialPage: page, pageSize: pageSize });
  }

  backButton() {
    this.props.navigate("/customerAnalytics");
  }

  render() {
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          {!this.props.isTab && (
            <MenuWithBreadScrum
              breadCrumb={this.breadCrumb}
              navigate={this.props.navigate}
              domainObject="Customer"
              // name="Customer List"
            />
          )}
          {this.state.customerList.length > 0 ? (
            <>
              <div className="row pe-2">
                <div className="col-md-12 text-end p-2">
                  <ReactToPrint
                    trigger={() => (
                      <Button
                        variant="contained"
                        size="small"
                        id="printBtn"
                        style={{
                          background: "#0577ab",
                          color: "#fff",
                          padding: "7px",
                          width: "100px",
                        }}
                        startIcon={<PrintRoundedIcon />}
                      >
                        print
                      </Button>
                    )}
                    content={() => this.componentRef}
                  />
                </div>
              </div>
              <div style={{ maxWidth: "100%" }}>
                <MaterialTable
                  title="Customer List"
                  tableRef={(el) => (this.componentRef = el)}
                  icons={UiUtils.getMaterialTableIcons()}
                  localization={{
                    body: {
                      emptyDataSourceMessage: "Please add customer",
                    },
                  }}
                  columns={[
                    {
                      title: "#",
                      render: (rowData) => rowData.tableData.id + 1,
                      width: "5%",
                      align: "left",
                      cellStyle: {
                        width: "6%",
                      },
                    },
                    {
                      title: "Name",
                      field: "name",
                      cellStyle: {
                        width: "18%",
                      },
                    },
                    {
                      title: "Type",
                      field: "type",
                      cellStyle: {
                        width: "15%",
                      },
                    },
                    {
                      title: "GSTN",
                      field: "gstn",
                      cellStyle: {
                        width: "18%",
                      },
                    },
                    {
                      title: "Address",
                      field: "address",
                      cellStyle: {
                        width: "30%",
                      },
                    },
                    {
                      title: "Status",
                      field: "status",
                    },
                  ]}
                  data={this.state.customerList}
                  options={{
                    sorting: true,
                    search: false,
                    actionsColumnIndex: -1,
                    initialPage: this.state.initialPage,
                    pageSize: this.state.pageSize,
                    pageSizeOptions: Utils.materialTablePageSize(),
                    paging: this.state.isPaging,
                    headerStyle: {
                      backgroundColor: "#0B6F9D",
                      fontWeight: "bold",
                      color: "#ffff",
                      align: "left",
                    },
                  }}
                  // actions={[
                  // 	{
                  // 		icon: () =>
                  // 		(
                  // 			<ReactToPrint
                  // 				trigger={() => (
                  // 					<Button
                  // 						variant="contained"
                  // 						size="small"
                  // 						id="printBtn"
                  // 						style={{ background: '#0577ab', color: "#fff", padding: "7px", width: "100px" }}
                  // 						startIcon={<PrintRoundedIcon />}
                  // 					>
                  // 						print
                  // 					</Button>
                  // 				)}
                  // 				content={() => this.componentRef}
                  // 			/>
                  // 		),
                  // 		tooltip: 'Print',
                  // 		isFreeAction: true,
                  // 	},
                  // ]}
                />
              </div>
              {!this.props.isTab && (
                <div className="row pe-2 mt-3">
                  <div className="col-md-6 text-start p-2">
                    <BackIconButton onClick={this.backButton.bind(this)} />
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className="row">
              <div className="col-md-12">
                <Card>
                  <CardBody>
                    <div className="row">
                      <div className="col-md-12" style={{ padding: "2em" }}>
                        <h5>
                          <b>Customer not created yet</b>
                        </h5>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </div>
            </div>
          )}
        </>
      );
    }
  }
}
export default withRouter(CustomerReportList);
